// clickable-field.component.ts
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-clickable',
  template: `
    <div *ngFor="let file of to.files">
        <a *ngIf="to.files.length" [href]="file.href" target="_blank" class="pointer">{{ file.fileName }}</a>
    </div>
    <span *ngIf="to?.files?.length ===0"><label>_</label></span>
  `,
})
export class ViewUploadedFileComponent extends FieldType {
//   onClick(event: Event) {
//     event.preventDefault();
//     if (this.to.onClick) {
//       this.to.onClick(this.field, this.field.model);
//     }
//   }
}
